module.exports = __webpack_public_path__ + "img/music.931aa1e7.svg";